import React, { useCallback, useState, useEffect } from "react";
// import UserItme from "./UserItme";
import { UserBoxMain } from "../styles/UserBoxStyles";
// import users from "./users.json";
// import admin_login from "../../../../assets/images/admin_login.png";
import {
  UserItmeMain,
  UserAvatar,
  UserItmeWrap,
  Userdetails,
  Usertime,
} from "../styles/UserBoxStyles";
import { CustomScrollbarStyle } from "../../../customer/messages/styles/ScrollbarStyles";
import { formatTime } from "../../../../helpers/formatTime";
import { UpdateChatUnread } from "../../../../services/admin/chat";

const UserBox = ({
  AllData,
  activeIndex = {},
  setActiveIndex = () => {},
  setUserObj = () => {},
}) => {
  const [ShowUsers, setShowUsers] = useState([]);

  useEffect(() => {
    setShowUsers(AllData?.data);
  }, [AllData]);
  console.log("🚀 ~ file: UserBox.js:28 ~ AllData:", AllData);

  const handelClick = useCallback(
    async (index, value) => {
      setActiveIndex(index);
      setUserObj(value);

      // main page scroll to bottom

      window.scrollTo({
        top: document.body.scrollHeight,
        behavior: "smooth", // Optional: Smooth scrolling animation
      });
      // End  main page scroll to bottom

      // === update the unread message ===

      if (value?.user_slug !== 0) {
        const respons = await UpdateChatUnread(value?.user_slug);
        if (respons?.status === 200) {
          const updatedUsers = ShowUsers.map((user, i) => {
            if (i === index) {
              return {
                ...user,
                unread_count: 0,
              };
            }
            return user;
          });
          setShowUsers(updatedUsers);
        }
      }
    },
    [setActiveIndex, setUserObj, ShowUsers]
  );
  return (
    <UserBoxMain className="UserBoxMain">
      <CustomScrollbarStyle>
        {/* <UserItme /> */}

        <UserItmeMain>
          {ShowUsers && ShowUsers?.length > 0 ? (
            <>
              {ShowUsers?.map((value, index) => {
                const uniqueKey = `${value?.user_slug}_${index}}`;
                const isActive = index === activeIndex ? "active" : "";
                return (
                  <UserItmeWrap
                    key={uniqueKey}
                    className={isActive}
                    onClick={() => handelClick(index, value)}
                  >
                    <div className="userprofile">
                      <UserAvatar alt="userimage" src={value?.user_image} />
                    </div>
                    <Userdetails>
                      <h6>{value?.user_name}</h6>
                      <p>{value?.message}</p>
                    </Userdetails>
                    <Usertime>
                      {value?.unread_count > 0 && (
                        <>
                          <span className="count">{value?.unread_count}</span>
                        </>
                      )}

                      <span className="time">
                        {formatTime(value?.created_at)}
                      </span>
                    </Usertime>
                  </UserItmeWrap>
                );
              })}
            </>
          ) : (
            <>
              <p className="Nouser">No user found</p>
            </>
          )}
        </UserItmeMain>
      </CustomScrollbarStyle>
    </UserBoxMain>
  );
};

export default UserBox;
